import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import ToggleCell from '@/components/table/ToggleCell';
import { columnEnforced, columnName, hasColumn } from '@/constants/fields';
import { showRemoveDatasetCondition, toggleDatasetConditionAdvisory } from '../actions';
import DatasetConditionNameCell from '../components/DatasetConditionNameCell';
import { isAdvisory, isWorkspaceCondition } from '../helper';

const DatasetConditionRow = ({
  canEdit,
  category,
  code,
  columns = [columnName, columnEnforced],
  datasetCondition,
  name,
  removeCondition,
  showCondition,
  toggleAdvisory,
}) => {
  const { condition } = datasetCondition;

  return (
    <Table.Row className="aridhia-dataset-condition-row" verticalAlign="top">
      {hasColumn(columns, columnName) && (
        <DatasetConditionNameCell
          datasetCondition={datasetCondition}
          onClick={showCondition ? () => showCondition(category, code, datasetCondition.id, name) : undefined}
          colSpan={hasColumn(columns, columnEnforced) && !isWorkspaceCondition(condition) ? 2 : 1}
          code={code}
        />
      )}
      {hasColumn(columns, columnEnforced) && isWorkspaceCondition(condition) && (
        <ToggleCell
          checked={!isAdvisory(datasetCondition)}
          label={condition.name}
          disabled={!canEdit}
          onClick={() => toggleAdvisory(category, code, datasetCondition.id, name)}
        />
      )}
      {canEdit && (
        <Table.Cell collapsing>
          <RowDeleteButton
            entity="dataset.condition"
            floated="right"
            iconName="trash alternate"
            onClick={() => removeCondition(category, code, datasetCondition.id, name)}
          />
        </Table.Cell>
      )}
    </Table.Row>
  );
};

const mapDispatchToProps = {
  removeCondition: showRemoveDatasetCondition,
  toggleAdvisory: toggleDatasetConditionAdvisory,
};

export default connect(null, mapDispatchToProps)(DatasetConditionRow);
